import _ from 'lodash';
import TokboxVideoProvider from './tokbox-video-provider.class';
import OTSession from './ot-session.class';

export default angular
  .module('doxy.providers.video.tokbox', [])
  .service('OTSession', OTSession)
  .service('TokboxVideoProvider', TokboxVideoProvider).name;
